// src/components/Home/AboutSection.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './AboutSection.css';

const AboutSection = () => {
  // First 4 members from the Planning Committee (matches About page order)
  const committeeMembers = [
    { 
      name: 'Hon. Moses O.T. Owharo', 
      role: 'Chairman, Planning & Organising Committee', 
      image: '/images/speakers/moses-owharo.jpeg',
      placeholder: '👤'
    },
    { 
      name: 'H.E. Amb. Faruk Malami Yabo, MFR', 
      role: 'Technical Advisor – Diplomacy & International Relations', 
      image: '/images/speakers/Faruk-Yabo.jpg',
      placeholder: '🌍'
    },
    { 
      name: 'H.E. Amb. (Mrs.) Mobalaji S. Ogundero', 
      role: 'Technical Advisor – International Cooperation', 
      image: '/images/speakers/Mobalaji.jpeg',
      placeholder: '🌍'
    },
    { 
      name: 'Prof. M. T. Ladan', 
      role: 'Technical Advisor – Regional Integration & Sustainable Development', 
      image: '/images/speakers/prof-ladan.jpg',
      placeholder: '📚'
    }
  ];

  // Partners logos - Updated Zenith logo
  const partners = [
    { name: 'Presidency', logo: '/images/hero/presidency.png' },
    { name: 'ABVIG', logo: '/images/hero/abvig-logo.jpg' },
    { name: 'Foreign Affairs', logo: '/images/hero/foreign-affairs.jpg' },
    // { name: 'Afreximbank', logo: '/images/hero/afrexim.png' },
    { name: 'ICAD', logo: '/images/hero/icad.jpeg' },
    { name: 'Zenith', logo: '/images/hero/zenith-w-bg.jpeg' },  // ← UPDATED
    { name: 'FCMB', logo: '/images/hero/fcmb.jpg' },
    { name: 'AfCFTA', logo: '/images/hero/afcfta.jpg' },
    { name: 'UNDP', logo: '/images/hero/undp.jpg' },
    { name: 'SDG', logo: '/images/hero/sdg.png' }
  ];

  return (
    <section className="about-section">
      <div className="about-container">
        <div className="about-header">
          <span className="about-badge">ABOUT THE SUMMIT</span>
          <h2 className="about-title">Africa Climate Change Summit</h2>
          <div className="about-title-line"></div>
        </div>
        
        <div className="about-content">
          <div className="about-text">
            <p className="about-description">
              The Africa Climate Change Summit (AICIS 2026) is Africa's premier, policy-aligned investment platform bringing together governments, global investors, development finance institutions, private sector leaders, and innovators to accelerate sustainable development and climate-resilient growth across the continent.
            </p>
            
            <div className="about-highlights">
              <div className="highlight-item">
                <div className="highlight-number">3,000+</div>
                <div className="highlight-label">Participants & Exhibitors</div>
              </div>
              <div className="highlight-item">
                <div className="highlight-number">56</div>
                <div className="highlight-label">Countries Represented</div>
              </div>
              <div className="highlight-item">
                <div className="highlight-number">$12T</div>
                <div className="highlight-label">Investment Opportunities</div>
              </div>
            </div>
          </div>
        </div>

        {/* ===== PLANNING & ORGANISING COMMITTEE - FIRST 4 MEMBERS ===== */}
        <div className="committee-section-home">
          <div className="committee-header-home">
            <span className="committee-badge-home">COMMITTEE</span>
            <h3 className="committee-title-home">AICIS Planning & Organising Committee</h3>
            <div className="committee-line-home"></div>
          </div>
          
          <div className="committee-grid-home">
            {committeeMembers.map((member, index) => (
              <div className="committee-card-home" key={index}>
                <div className="committee-image-wrapper-home">
                  {member.image ? (
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="committee-image-home"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = `<div class="committee-placeholder-home">${member.placeholder}</div>`;
                      }}
                    />
                  ) : (
                    <div className="committee-placeholder-home">{member.placeholder}</div>
                  )}
                </div>
                <h4 className="committee-name-home">{member.name}</h4>
                <p className="committee-role-home">{member.role}</p>
              </div>
            ))}
          </div>

          {/* View Full Committee Button */}
          <div className="committee-view-all">
            <Link to="/events/about#committee" className="committee-view-btn">
              View Full Planning Committee →
            </Link>
          </div>
        </div>

        {/* ===== PARTNERS & COLLABORATORS ===== */}
        <div className="partners-section-home">
          <div className="partners-header-home">
            <span className="partners-badge-home">PARTNERS</span>
            <h3 className="partners-title-home">Our Partners & Collaborators</h3>
            <div className="partners-line-home"></div>
          </div>
          <div className="partners-grid-home">
            {partners.map((partner, index) => (
              <div className="partner-item-home" key={index}>
                <img src={partner.logo} alt={partner.name} />
                <span>{partner.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;